export const WebSocket = typeof window !== "undefined" && window.WebSocket ? window.WebSocket : class {
	constructor() {
		throw new Error("WebSocket is not available in this environment");
	}
};
export default { WebSocket };


